var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_606",
    "data-name": "Rectangle 606",
    width: 24,
    height: 24,
    transform: "translate(609 311)",
    fill: "#da0011",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_46",
    "data-name": "Mask Group 46",
    transform: "translate(-609 -311)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "face-awesome-regular",
    d: "M10.5,9.375V10.5A1.5,1.5,0,0,1,9,12H5.25a1.5,1.5,0,0,1-1.5-1.5V9.375a3.375,3.375,0,0,1,6.75,0ZM9,10.5V9.375A1.728,1.728,0,0,0,8.981,9.1a1.206,1.206,0,0,1-.731.272A1.123,1.123,0,0,1,7.4,7.519,2.14,2.14,0,0,0,7.125,7.5,1.874,1.874,0,0,0,5.25,9.375V10.5Zm10.5-.75v.839A1.412,1.412,0,0,1,18.089,12H13.411a1.449,1.449,0,0,1-1.453-1.411V9.75a3.771,3.771,0,0,1,7.542,0Zm-3.375-1.5a1.137,1.137,0,0,1,.22-.67A2.252,2.252,0,0,0,13.5,9.75v.75H18V9.75a2.253,2.253,0,0,0-.08-.6,1.137,1.137,0,0,1-.67.22A1.122,1.122,0,0,1,16.125,8.25ZM5.452,13.5h13.1a.762.762,0,0,1,.745.928,7.479,7.479,0,0,1-.914,2.259,7.366,7.366,0,0,1-6.328,3.52L12,20.25c-.216,0-.436-.009-.647-.028a7.47,7.47,0,0,1-6.647-5.794.763.763,0,0,1,.745-.928Zm10.406,2.25a3.868,3.868,0,0,0-3.764,2.958,5.865,5.865,0,0,0,4.978-2.761,3.831,3.831,0,0,0-1.214-.2ZM24,12A12,12,0,1,1,12,0,12,12,0,0,1,24,12ZM12,2.25A9.75,9.75,0,1,0,21.75,12,9.749,9.749,0,0,0,12,2.25Z",
    transform: "translate(609 311)",
    fill: "#da0011"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.3ca57baecf3b92caec9a57c32d4c7282.svg";
export { ForwardRef as ReactComponent };